// extracted by mini-css-extract-plugin
module.exports = {"collapse_override":"styles_collapse_override__36H-s","header":"styles_header__xsM5Q"};